import React, { useCallback, useEffect, useRef, useState } from 'react';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import { ReactComponent as CleanIcon } from '../../../assets/icons/ubr_clean.svg';
import { ReactComponent as Delete } from '../../../assets/icons/ubr_delete.svg';
import { ReactComponent as Edit } from '../../../assets/icons/ubr_edit.svg';
import { ReactComponent as FilterIcon } from '../../../assets/icons/ubr_filter.svg';
import { ReactComponent as Question } from '../../../assets/icons/ubr_question.svg';
import { ReactComponent as SearchIcon } from '../../../assets/icons/ubr_search.svg';
import {
  Button,
  Input,
  Layout,
  Modal,
  Pagination,
  Shimmer,
} from '../../../components';
import { useToast } from '../../../hooks/toast';
import useRedirect from '../../../hooks/useRedirect';
import { RoutesPaths } from '../../../routes';
import api from '../../../services/api';
import { EndpointsAPI } from '../../../services/Endpoints';
import getValidationErrors from '../../../utils/getValidationErrors';
import { LoadingData, TableContainer } from '../../Motor/Cobranca/styles';
import { ActionsForm, Info, InputGroup, FormContainer } from './styles';

interface DataProps {
  pageable: [
    {
      pageNumber: number;
      pageSize: number;
    },
  ];
  totalElements: number;
  totalPages: number;
}

interface SearchProps {
  campo: string | undefined;
}

const Lista: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);
  let [data, setData] = useState<DataProps | any>([]);
  const [idToDelete, setIdToDelete] = useState<string>('');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [pageSizeData, setPageSizeData] = useState<number>(5);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const redirect = useRedirect();
  const { addToast } = useToast();
  const formRef = useRef<FormHandles | null>(null);
  const homologData = useRef<any>();

  const fetchData = useCallback(
    async (apiPage: number, apiPageSize: number) => {
      // page number e page size tem que ser useState, modificados no onPageSize
      const { data } = await api.get(
        `${EndpointsAPI.mensagemCriticaPaginado}/${apiPage}/${apiPageSize}`,
      );

      setData(data);
      setIsLoading(false);
    },
    [],
  );

  useEffect(() => {
    fetchData(0, pageSizeData);
  }, []);

  const loadingTable = () => {
    return (
      <tr>
        <td>
          <div
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </div>
        </td>
        <td>
          <div
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </div>
        </td>
        <td>
          <ul
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </ul>
        </td>
        <td>
          <ul
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </ul>
        </td>
        <td>
          <div
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </div>
        </td>
      </tr>
    );
  };

  // Render Posts

  const renderPost = () => {
    let { pageSize, totalPages } = data;
    return (
      <>
        <TableContainer>
          <div>
            <table id="tableData">
              <thead>
                <tr>
                  <th style={{ width: '150px' }}>Campo</th>
                  <th style={{ width: '200px' }}>Mensagem</th>
                  <th style={{ width: '200px' }}>
                    Tipos de Validação de Críticas
                  </th>
                  <th style={{ width: '150px' }}>Tipos de Validação</th>
                  <th style={{ width: '150px' }}>
                    Ações{' '}
                    <Info
                      style={{
                        position: 'absolute',
                        top: '0.5rem',
                        right: '2rem',
                      }}
                    >
                      <span className="tooltip">
                        <div style={{ textAlign: 'left' }}>
                          Campo: campo para a mensagem
                          <br></br>
                          Mensagem: mensagem para apresentar no erro
                          <br></br>
                          Tipo de validação: arquivo para validação
                        </div>
                      </span>
                      <Question width={20} />
                    </Info>
                  </th>
                </tr>
              </thead>
              {isLoading ? (
                <tbody>
                  {loadingTable()}
                  {loadingTable()}
                  {loadingTable()}
                </tbody>
              ) : !data ? (
                <LoadingData> Sem dados para exibir... </LoadingData>
              ) : (
                <tbody>
                  {data.content ? (
                    <>
                      {data.content.map((todo: any, index: number) => (
                        <>
                          <tr key={index}>
                            <td data-column="Chave">
                              <p className="letterUpercase">
                                {todo.chave.length > 30
                                  ? todo.chave.substring(0, 30 - 3) + '...'
                                  : todo.chave}

                                {todo.chave.length > 30 && (
                                  <span className="tooltip">{todo.chave}</span>
                                )}
                              </p>
                            </td>
                            <td data-column="Mensagem">
                              {/* {todo.mensagem} */}
                              <p className="letterUpercase">
                                {todo.mensagem.length > 80
                                  ? todo.mensagem.substring(0, 80 - 3) + '...'
                                  : todo.mensagem}

                                {todo.mensagem.length > 80 && (
                                  <span className="tooltip">
                                    {todo.mensagem}
                                  </span>
                                )}
                              </p>
                            </td>
                            <td data-column="TiposValidacaoCritica">
                              <ul>
                                <>
                                  {todo.tiposValidacaoCritica !== null
                                    ? todo.tiposValidacaoCritica.map(
                                        (item: any, index: number) => {
                                          return <li key={index}>{item}</li>;
                                        },
                                      )
                                    : 'null'}
                                </>
                              </ul>
                            </td>
                            <td data-column="TiposValidacao">
                              <ul>
                                <>
                                  {todo.tiposValidacao !== null
                                    ? todo.tiposValidacao.map(
                                        (item: any, index: number) => {
                                          return <li key={index}>{item}</li>;
                                        },
                                      )
                                    : 'null'}
                                </>
                              </ul>
                            </td>
                            <td data-column="Ações">
                              <div>
                                <Button
                                  color={'#ab934b'}
                                  variant="solid-icon"
                                  onClick={() =>
                                    redirect(
                                      RoutesPaths.editCriticalMessage +
                                        `${todo.id}`,
                                    )
                                  }
                                  tooltipText={'Editar'}
                                >
                                  <Edit style={{ width: '20px' }} />
                                </Button>
                                <Button
                                  color={'#C71F37'}
                                  variant="solid-icon"
                                  onClick={() =>
                                    setTimeout(() => {
                                      openModal(todo.id);
                                    }, 500)
                                  }
                                  tooltipText={'Excluir'}
                                >
                                  <Delete style={{ width: '20px' }} />
                                </Button>
                              </div>
                            </td>
                          </tr>
                        </>
                      ))}
                    </>
                  ) : null}
                  {data.length ? (
                    <>
                      {data.map((todo: any, index: number) => (
                        <>
                          <tr key={index}>
                            <td data-column="Chave">
                              <p className="letterUpercase">
                                {todo.chave.length > 30
                                  ? todo.chave.substring(0, 30 - 3) + '...'
                                  : todo.chave}

                                {todo.chave.length > 30 && (
                                  <span className="tooltip">{todo.chave}</span>
                                )}
                              </p>
                            </td>
                            <td data-column="Mensagem">
                              {/* {todo.mensagem} */}
                              <p className="letterUpercase">
                                {todo.mensagem.length > 80
                                  ? todo.mensagem.substring(0, 80 - 3) + '...'
                                  : todo.mensagem}

                                {todo.mensagem.length > 80 && (
                                  <span className="tooltip">
                                    {todo.mensagem}
                                  </span>
                                )}
                              </p>
                            </td>
                            <td data-column="TiposValidacaoCritica">
                              <ul>
                                <>
                                  {todo.tiposValidacaoCritica !== null
                                    ? todo.tiposValidacaoCritica.map(
                                        (item: any, index: number) => {
                                          return <li key={index}>{item}</li>;
                                        },
                                      )
                                    : 'null'}
                                </>
                              </ul>
                            </td>
                            <td data-column="TiposValidacao">
                              <ul>
                                <>
                                  {todo.tiposValidacao !== null
                                    ? todo.tiposValidacao.map(
                                        (item: any, index: number) => {
                                          return <li key={index}>{item}</li>;
                                        },
                                      )
                                    : 'null'}
                                </>
                              </ul>
                            </td>
                            <td data-column="Ações">
                              <div>
                                <Button
                                  color={'#ab934b'}
                                  variant="solid-icon"
                                  onClick={() =>
                                    redirect(
                                      RoutesPaths.editCriticalMessage +
                                        `${todo.id}`,
                                    )
                                  }
                                  tooltipText={'Editar'}
                                >
                                  <Edit style={{ width: '20px' }} />
                                </Button>
                                <Button
                                  color={'#C71F37'}
                                  variant="solid-icon"
                                  onClick={() =>
                                    setTimeout(() => {
                                      openModal(todo.id);
                                    }, 500)
                                  }
                                  tooltipText={'Excluir'}
                                >
                                  <Delete style={{ width: '20px' }} />
                                </Button>
                              </div>
                            </td>
                          </tr>
                        </>
                      ))}
                    </>
                  ) : null}
                </tbody>
              )}
            </table>
          </div>
        </TableContainer>

        <div>
          <Pagination
            pageCount={totalPages}
            marginPagesDisplayed={2}
            pageRangeDisplayed={pageSize}
            forcePage={currentPage - 1}
            onPageChange={(pageNumber: { selected: number }) => {
              setCurrentPage(pageNumber.selected + 1);
              fetchData(pageNumber.selected, pageSizeData);
            }}
            onPageSize={(pageSize) => {
              setCurrentPage(1);
              setPageSizeData(pageSize.value);
              fetchData(0, pageSize.value);
            }}
          />
        </div>
      </>
    );
  };

  const deleteCard = async () => {
    closeModal();
    await api.delete(`${EndpointsAPI.mensagemCritica}/${idToDelete}`);

    addToast({
      type: 'success',
      title: 'Mensagem crítica excluída com sucesso!',
      description: 'A Mensagem crítica foi removida.',
    });

    fetchData(0, pageSizeData);
  };

  const openModal = (id: string) => {
    setIdToDelete(id);
    setShowDeleteModal(true);
  };

  const closeModal = () => {
    setShowDeleteModal(false);
  };

  const handleFilter = async (dataFilter: SearchProps) => {
    try {
      formRef.current?.setErrors({});

      const schema = Yup.object().shape({
        campo: Yup.string().required('Este campo é obrigatório!'),
      });

      await schema.validate(dataFilter, {
        abortEarly: false,
      });

      const response = await api.get(`${EndpointsAPI.mensagemCritica}`);
      homologData.current = response.data || [];

      let filteredData = homologData.current;

      filteredData = filteredData.filter(
        (item: any) => item.chave === dataFilter.campo,
      );

      let filter = (data.content = filteredData);
      data.totalElements = filteredData.length;
      data.totalPages = 1;

      setData(filter);
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const errorMessages = getValidationErrors(err);
        formRef.current?.setErrors(errorMessages);
        return;
      }
    }
  };

  const onClear = () => {
    formRef.current?.reset();
    formRef.current?.setErrors({});
    fetchData(0, pageSizeData);
  };

  return (
    <>
      <Modal
        show={showDeleteModal}
        titulo={'Excluir Mensagem de Crítica'}
        mensagem={'Confirma a exclusão da Mensagem de Crítica?'}
        onConfirm={() => deleteCard()}
        onCancel={() => closeModal()}
        actionButtons
      />
      <Layout
        title={'Lista de mensagens criticas'}
        titlePage={'Mensagens críticas'}
        buttonTitle={'Nova mensagem critica'}
        buttonRedirect={`${RoutesPaths.registerCriticalMessage}`}
      >
        <Form className="form-container" ref={formRef} onSubmit={handleFilter}>
          <FormContainer>
            <FilterIcon width={28} />
            <InputGroup>
              <Input
                name="campo"
                label="Campo"
                type="text"
                placeholder="Ex.: dataVencimento"
              />
            </InputGroup>
            <ActionsForm>
              <div>
                <Button
                  variant="solid-icon"
                  type={'submit'}
                  style={{ marginRight: '1rem' }}
                  tooltipText={'Pesquisar'}
                >
                  <SearchIcon style={{ width: '26px' }} />
                </Button>
                <Button
                  variant="solid-icon"
                  type={'reset'}
                  onClick={onClear}
                  tooltipText={'Limpar campo'}
                >
                  <CleanIcon style={{ width: '26px' }} />
                </Button>
              </div>
            </ActionsForm>
          </FormContainer>
        </Form>

        {data && renderPost()}
      </Layout>
    </>
  );
};

export default Lista;
